import type React from "react";
import { type TextProps, View, XStack } from "tamagui";
import { stringTrimList } from "../core/utils";
import type { IconProp } from "./icons";
import { Subtext } from "./Subtext";

export type InfoRowItemProps = {
  text: JSX.Element | string;
  icon?: IconProp | string | null;
  trim?: string;
  textProps?: TextProps;
};

export const InfoRowItem: React.FC<{ item: InfoRowItemProps }> = ({ item }) => {
  const Icon = typeof item.icon === "string" ? undefined : item.icon;
  const emoji = typeof item.icon === "string" ? item.icon : undefined;

  let text = item.text;

  if (typeof item.text === "string" && item.trim) {
    const splitText = item.text.split(item.trim);
    text = stringTrimList(splitText);
  }

  return (
    <XStack maxWidth="100%" gap={"$small"}>
      {Icon && <Icon color={"$muted"} size={"$size.small"} />}
      {emoji && (
        <View>
          <Subtext>{emoji}</Subtext>
        </View>
      )}
      <Subtext {...item.textProps}>{text}</Subtext>
    </XStack>
  );
};

export const InfoRow: React.FC<{ items: (InfoRowItemProps | undefined)[] }> = ({
  items,
}) => {
  return (
    <XStack flexWrap="wrap" gap="$medium">
      {items.map((item, index: number) =>
        item ? <InfoRowItem key={`${index}`} item={item} /> : null,
      )}
    </XStack>
  );
};
